/**
 * @file 고객센터 화면  Data
 */

/**
 * @constant 고스테이션 안내 게시글 관련 Data
 * @type title 자료명 title
 * @type date 해당기종
 * @type filePath file url
 * @type fileType file 확장자명
 * @type fileTypeText file 확장자 사용자에게 표시
 */
export const DOWNLOAD_INFO = [
    {
        title: '닷스테이션 대리점 지원신청서',
        file_name: '닷스테이션_대리점_지원신청서',
        kind: '',
        path: require('assets/manual/닷스테이션 대리점 개설신청서.docx'),
        fileType: 'docx',
        fileTypeText: 'DOC',
    },
    {
        title: '사용설명서',
        file_name: '고고로 사용설명서',
        kind: 'Gogoro 2 UTILITY, Gogoro 2 PLUS, S2',
        path: require('assets/manual/고고로 사용설명서.pdf'),
        fileType: 'pdf',
        fileTypeText: 'PDF',
    },
    {
        title: '빠른사용을 위한 가이드',
        file_name: '고고로 퀵가이드',
        kind: 'Gogoro 2 UTILITY, Gogoro 2 PLUS, S2',
        path: require('assets/manual/고고로 퀵가이드.pdf'),
        fileType: 'pdf',
        fileTypeText: 'PDF',
    },
    {
        title: '사용설명서',
        file_name: 'EV-C1 사용설명서',
        kind: 'EV-C1',
        path: require('assets/manual/EV-C1 사용설명서.pdf'),
        fileType: 'pdf',
        fileTypeText: 'PDF',
    },
    {
        title: '빠른사용을 위한 가이드',
        file_name: 'EV-C1 퀵가이드',
        kind: 'EV-C1',
        path: require('assets/manual/EV-c1 퀵가이드.pdf'),
        fileType: 'pdf',
        fileTypeText: 'PDF',
    },
    {
        title: '전체 앱 사용 가이드',
        file_name: '전체 앱 사용 가이드',
        kind: ' EV-C1, Gogoro 2 Plus, S2',
        path: require('assets/manual/전체앱사용가이드.pdf'),
        fileType: 'pdf',
        fileTypeText: 'PDF',
    },
]
